import angular from 'angular';
import providersContainer from './providersContainer';
import './style.scss';

export default angular
  .module('components.providerInformationsContainers', [])
  .component('providerInformationsContainers', providersContainer).name;
